import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const StyledQuantityTag = styled(Spacer)`
  font-weight: bold;
  font-size: ${(props) => props.theme.base.textSizes.XL};
`;

export default StyledQuantityTag;
